<template>
  <div
    class="container mx-auto flex flex-col items-center font-Almarai relative overflow-x-hidden"
  >
    <LogoSvg class="absolute" />

    <div class="flex justify-center items-center w-3/12  h-36">
      <img src="@/assets/logo-1.webp" alt="logo" class="w-28" />
    </div>
    <!-- Main Content -->
    <div
      class="flex flex-col justify-center items-center gap-y-6 bg-transparent rounded-md md:mx-auto mx-2"
    >
      <div class="my-2 flex flex-col justify-center items-center">
        <h1 class="md:text-2xl font-bold text-white my-2 font-Almarai">معلومات الدفع</h1>
        <!-- daily section -->
        <div class="my-3 md:w-10/12 w-full md:px-6 px-1 py-4 rounded-md" dir="rtl">
          <div class="flex justify-between items-center mx-3">
            <h1 class="text-md text-white font-bold">  اختر طريقة الدفع </h1>
          </div>
          <!-- operators sections  -->
          <div class="flex justify-between p-2">
            <sudani-option
              @click="showOperator(0)"
              :selectedProvider="selectedProvider"
            />
            <bravo-option @click="showOperator(1)" :selectedProvider="selectedProvider" />
          </div>
        </div>
        <!-- end of daily -->

        <!-- end of stripe plans -->
      </div>
      <div class="flex flex-col items-center gap-y-2 justify-center w-full mx-auto my-3">
        <button
          @click.prevent="redirectUserToProvider"
          class="inline-flex justify-center items-center gap-2 md:w-10/12 w-full bg-[#9d2890] text-gray-100 rounded-md py-3"
        >
          <span> متابعة </span>
        </button>
        <button
          @click.prevent="$router.go(-1)"
          class="inline-flex justify-center items-center gap-2 md:w-10/12 w-full border border-basic text-gray-100 rounded-md py-3"
        >
          <span> رجوع </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import animationData from "@/assets/loader.json";
import LogoSvg from "@/components/svg/LogoSvg.vue";
import SudaniOption from "@/components/payments/SudaniOption.vue";
import BravoOption from "@/components/payments/BravoOption.vue";

export default {
  components: {
    LogoSvg,
    SudaniOption,
    BravoOption,
  },
  data() {
    return {
      toast: useToast(),
      loaded: false,
      lottieOptions: {
        animationData,
        loop: true,
        autoplay: true,
      },
      jsonFile: animationData,
      providers: {
        sudani: "https://sudanipay.com/subscription/nasna/NasnaTVMonthly",
        bravo: "bravo.pay",
      },
      selectedProvider: null,
    };
  },

  methods: {
    showOperator(id) {
      switch (id) {
        case 0:
          this.selectedProvider = "sudani";
          break;
        case 1:
          this.selectedProvider = "bravo";
          break;
        default:
          this.selectedProvider = "sudani";
      }
    },

    redirectUserToProvider() {
      this.loaded = true;
      if (this.selectedProvider) {
        if (this.providers[this.selectedProvider] && this.selectedProvider === "sudani") {
          window.location.href = this.providers[this.selectedProvider];
        } else if (this.selectedProvider === "bravo") {
            this.$router.push({ name: "bravo.pay" });
        }else{
             this.toast.error("احتر الباقة المناسبة ");
        }
      }
      this.loaded = false;
    },
  },
};
</script>

<style scoped>
/* Your existing styles */
</style>

<style scoped></style>
